import axios from '@/lib/axios';
import { useEffect } from 'react';

export default function useYeamazingToken() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('yeamazing_cashback');

    // console.log(token);

    if (token) {
      axios.post('/api/v2/yeamazing/capture-token', {
        yeamazing_cashback: token,
      });

      // Store temporarily in localStorage for order
      localStorage.setItem('yeamazing_cashback', token);

      // optional: clean URL
      params.delete('yeamazing_cashback');
      window.history.replaceState({}, '', `${window.location.pathname}`);
    }
  }, []);
}
